/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'jquery',
    'mustache',
    'pip-model',
    'pip-events',
    'pip-common.tooltips',
    'pip-common.validate',
    'pip-common.dynamic_eta',
    'cookie-utils',
    'pip-common.utils'
  ],
  function(
    $,
    Mustache,
    pip,
    pipEvents,
    pipTooltips,
    pipValidate,
    pipDynamicEta,
    cookieUtils,
    pipCommonUtils
  ){

    var shippingServiceLevelsTooltip;
    var shippingServiceLevelsTooltipId = 'shippingServiceLevelsTooltip';

    var templates = {
      shipping__layout_parcel: $('#shipping__layout-parcel').html(),
      shipping__layout_parcel_bodfs_as_service_level: $('#shipping__layout-parcel_bodfs_as_service_level').html(),
      shipping__layout_non_parcel: $('#shipping__layout-non-parcel').html(),
      shipping__layout_non_parcel_bodfs_as_service_level: $('#shipping__layout-non-parcel_bodfs_as_service_level').html(),
      shipping__deliver_from_store: $('#shipping__deliver_from_store').html(),
      shipping__error: $('#shipping__error').html(),
      shipping__footer: $('#shipping__footer').html(),
      shipping__zip_code_input: $('#shipping__zip-code-input').html(),
      shipping__ajax_loader: $('#shipping__ajax-loader').html()
    }

    var model = {
      getServiceURL: function () {
        return "/p/svcs/shippingOptionsv2?itemId=" + pip.products.primary.data.itemId +
          "&quantity=" + pip.customer.quantity +
          "&price=" + (pip.products.primary.data.itemExtension.displayPrice * pip.customer.quantity).toFixed(2) +
          "&storeOrZip=" + shippingHelpers.getShippingZipCode();
      },
      getData: function () {
        return $.ajax({
          url : model.getServiceURL(),
          cache : false
        }).always(model.transformData);
      },
      transformData: function (data) {
        model.shippingResponse = data;
        if(pip.fulfillment && pip.fulfillment.shipping){
          pip.fulfillment.shipping.shippingServiceResponse = data;
        }


        if(!data || (data.status && typeof status === 'number' && data.status != 200) || !data.items || !data.items[0] || !data.items[0].deliveries || !data.items[0].deliveries[0]) {
          model.shippingResponse.isError = true;
          return;
        }

        model.viewModel = {
          shipModes: [],
          dynamicETA: {}
        }


        $.each(data.items[0].deliveries[0].shipModes, function (key, val) {

          if(key===0) {
            model.viewModel.arrivalDate = shippingHelpers.getArrivalDate(val.estArrivalStartDate, val.estArrivalEndDate, val.dynamicEtaOptimalDate);
            model.viewModel.arrivalDateIsSingleDate = (val.estArrivalStartDate === val.estArrivalEndDate);
            model.viewModel.formattedStartDate = shippingHelpers.formatDate(val.estArrivalStartDate, true);
            model.viewModel.formattedEndDate = shippingHelpers.formatDate(val.estArrivalEndDate, true);
            model.viewModel.hasFreeShipping = !val.totalCharge;
            model.viewModel.isFreeShippingEligible = !!val.freeShippingThreshold;
            model.viewModel.freeShippingThreshold = val.freeShippingThreshold;

            if(val.timeLeftMins){
              model.viewModel.dynamicETA.hasCountdownTimer = true;
              if(pip.fulfillment.shipping.shipToHome && !pip.fulfillment.shipping.shipToHome.dynamicEta) {
                pip.fulfillment.shipping.shipToHome.dynamicEta = {};
              }
              model.viewModel.dynamicETA.totalMinutes = (val.timeLeftHours * 60) + val.timeLeftMins
              pip.fulfillment.shipping.shipToHome.dynamicEta.totalMinutes = model.viewModel.dynamicETA.totalMinutes;
            }
          }

          model.viewModel.shipModes.push({
            description: val.modeDesc,
            hasBulletPoints: !!val.modeLongDesc,
            bulletPoints: val.modeLongDesc && val.modeLongDesc.split('||'),
            isFreeShippingEligible: !!val.freeShippingThreshold,
            freeShipEligibleMsg: "FREE with $" + val.freeShippingThreshold + " Order",
            isFreeShipping: val.totalCharge === 0,
            shipCharge: "$" + val.totalCharge.toFixed(2),
            arrivalDate: shippingHelpers.getArrivalDate(val.estArrivalStartDate, val.estArrivalEndDate, val.dynamicEtaOptimalDate),
            // The values immediately below are only provided when feature switch for bodfs-as-service-level is toggled on
            // as only then do we call the shipping service with a parameter allowing for their return.
            isBodfsShipMode: val.isBodfsShipMode,
            deliveryDateAvailability: val.deliveryDateAvailability && val.deliveryDateAvailability.toLowerCase(),
            isDeliveryTimelineTodayOrTomorrow: val.deliveryDateAvailability && (val.deliveryDateAvailability.toLowerCase() === "today" || val.deliveryDateAvailability.toLowerCase() === "tomorrow")
          });

        });
        pip.debugMode && console.log("Shipping Service data: ", model);
      }
    };

    var view = {
      getLayoutTemplate: function (model) {
        if(!model.shippingResponse || !model.shippingResponse.items) {
          return templates.shipping__error;
        }

        if(model.shippingResponse
          && model.shippingResponse.items
          && model.shippingResponse.items[0].deliveries
          && model.shippingResponse.items[0].deliveries[0].shipModes
          && model.shippingResponse.items[0].deliveries[0].shipModes[0].modeGroup
          && model.shippingResponse.items[0].deliveries[0].shipModes[0].modeGroup.toLowerCase() === 'parcel') {

          if (pip.features.bodfsAsServiceLevelFeature) {
            return templates.shipping__layout_parcel_bodfs_as_service_level;
          } else {
            return templates.shipping__layout_parcel;
          }

        } else if (pip.features.bodfsAsServiceLevelFeature) {
          return templates.shipping__layout_non_parcel_bodfs_as_service_level;
        } else {
          return templates.shipping__layout_non_parcel;
        }
      },
      showTooltip: function (model) {
        var tooltipHeaderMarkup = Mustache.to_html(model.shippingResponse.isError ? '' : templates.shipping__zip_code_input, pip.customer);
        if (pip.features.bodfsAsServiceLevelFeature) {
          var tooltipBodyMarkup = Mustache.render(view.getLayoutTemplate(model), model.viewModel, {'deliver_from_store': templates.shipping__deliver_from_store});
        } else {
          var tooltipBodyMarkup = Mustache.render(view.getLayoutTemplate(model), model.viewModel);
        }
        var tooltipFooterMarkup = model.shippingResponse.isError ? '' : templates.shipping__footer;

        shippingServiceLevelsTooltip.templates = {
          id: shippingServiceLevelsTooltipId,
          header: tooltipHeaderMarkup,
          body: tooltipBodyMarkup,
          footer: tooltipFooterMarkup
        };
        shippingServiceLevelsTooltip.title = 'Delivery Options for ' + shippingHelpers.getShippingZipCode();
        shippingServiceLevelsTooltip.rebuild();
        shippingServiceLevelsTooltip.display();
        if(model.viewModel.dynamicETA.hasCountdownTimer) {
          pipDynamicEta.initCountDownTimer();
        }
      },
      showAjaxLoader: function showAjaxLoader() {
        var tooltipInnerSelector = '#' + shippingServiceLevelsTooltipId + ' .tooltip_inner';

        $(tooltipInnerSelector).html(templates.shipping__ajax_loader);
      }
    }

    var longMonthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    var shortMonthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    var shippingHelpers = {
      getArrivalDate: function getArrivalDate(startDate, endDate, detaDate) {

        if(detaDate) {
          return detaDate;
        } else if(startDate === endDate) {
          return shippingHelpers.formatDate(startDate, true);
        }
        return shippingHelpers.formatDate(startDate, false) + " - " + shippingHelpers.formatDate(endDate, false);

      },
      formatDate: function formatDate(dateString, shouldUseFullMonthName) {
        var date = dateString.split('-');
        var shippingYear = date[0];
        var shippingMonth = date[1] - 1;
        var shippingDay =  date[2];
        var dateObject = new Date(shippingYear, shippingMonth, shippingDay, 0, 0, 0);
        if(shouldUseFullMonthName) {
          return longMonthNames[dateObject.getMonth()] + ' ' + dateObject.getDate();
        }
        return shortMonthNames[dateObject.getMonth()] + ' ' + dateObject.getDate();
      },
      getShippingZipCode: function getShippingZipCode() {
        if (pip.customer.dynamicEtaZipCode) {
          return pip.customer.dynamicEtaZipCode;
        }

        return pip.customer.localStore && pip.customer.localStore.zipCode
      },
      createDynamicEtaCookie: function createDynamicEtaCookie(dynamicEtaZipCode) {
        if (pip.features.detaZipDomain){
          pipCommonUtils.setCookieWithDomain('DETA_ZIP', dynamicEtaZipCode, null);
        }else{
          cookieUtils.fed_CreateCookie('DETA_ZIP', dynamicEtaZipCode, null);
        }

      }
    };

    function initTooltipEventListeners() {
      $(window.document).off('.shipping_service_levels_toolip')
      $(window.document).on('click.shipping_service_levels_toolip', '.tooltip_accordion_header', function(e) {
        e.preventDefault();
        var accordionHeaderParent = $(this).parent();
        accordionHeaderParent.find('ul').slideToggle(200);
        accordionHeaderParent.find('.icon').toggleClass('icon-plus-orange icon-minus-orange');
      });

      $(window.document).on('submit.shipping_service_levels_toolip', '#deta_change_zipcode', function detaZipCodeUpdateClicked(e) {
        e.preventDefault();
        e.stopPropagation();
        var detaZipCode = $('.deta_change_zipcode_input').val().replace(' ', '');
        if (pipValidate.validateZipCode(detaZipCode)) {
          pip.customer.setDynamicEtaZipCode(detaZipCode);
          shippingHelpers.createDynamicEtaCookie(detaZipCode);
          view.showAjaxLoader();
          loadShippingDataAndDisplayTooltip().then(function () {
            pipEvents.shippingOptions.shippingOptionsZipCodeWasChanged.trigger(model.viewModel);
          });

        } else {
          pipEvents.shippingOptions.shippingOptionsZipCodeCheckError.trigger();
        }
        pipEvents.shippingOptions.shippingOptionsZipCodeWasChecked.trigger();
      });

      $(window.document).on('click.shipping_service_levels_toolip', '.change_zipcode_Link', function changeDeliveryZipCodeClicked(e) {
        e.preventDefault();
        var zipSection = $(this).next();
        zipSection.addClass('active');
        zipSection.find('input[type=tel]').focus();
      });
    }


    function loadShippingDataAndDisplayTooltip() {
      return model.getData().always(function () {
        view.showTooltip(model);
      });
    }



    return {
      init: function init() {
        pip.customer.setDynamicEtaZipCode(
          cookieUtils.readBrowserCookie('DETA_ZIP') || pip.customer.localizedZipCode() || null
        );

        shippingServiceLevelsTooltip = pipTooltips.create({
          init: initTooltipEventListeners,
          callToActionSelector: '#shipping_options_link'
        });

        pipEvents.shippingOptions.shippingOptionsLinkClicked.off('.shippingOptionsLinkClicked');
        pipEvents.shippingOptions.shippingOptionsLinkClicked.on('.shippingOptionsLinkClicked', loadShippingDataAndDisplayTooltip);
      },
      shippingHelpers: shippingHelpers,
      model: model,
      view: view
    };
  });

}.call(window));